<script>
    import { tick } from 'svelte';

    let textarea;
    let show_message_form = true;
    let message_input = "";
    let message_response = "";
    let shake = false;

    function handleKey(event) {
        if(event.key == "Enter") {
            event.preventDefault();
            sendMessage();
        }
    }

    function sendMessage()
    {
        // check for empty messages
        if(message_input.trim().length == 0) {
            message_input = "";
            shake = true;
            setTimeout( () => { shake = false; }, 400);
            textarea.focus();
            return;
        }

        // show response
        message_response = "Sending message ...";
        show_message_form = false;

        let pdata = new FormData();
        pdata.append('message', message_input);
        pdata.append('origin', 'AP');

        // send message
        fetch('sender.php', { method: 'POST', body: pdata })    // 'https://www.leaf-pool.com/apollo/sender.php'
        .then(response => response.text())                      // response.json()
        .then(data => {
            console.log(data);
            if (data == "0") message_response = "The message is on its way, thanks for reaching out!";
            else if (data == "1") message_response = "Please add some text to the message.";
            else if (data == "2") message_response = "Your IP address is blacklisted. Please reach out to us via email or Telegram group.";
            else message_response = "An error occurred while sending the message. Please try again later.";
        }).catch(error => {
            message_response = "An error occurred while sending the message. Please try again later.";
        });
    }

    async function resetMessage()
    {
        message_input = "";
        show_message_form = true;
        await tick();   // wait for the DOM to be refreshed
        if(textarea) textarea.focus();
    }

</script>


<div class="container">
    <div class="col" style="min-width: 20em;">
        <div class="title" id="contacts">Contacts:</div>
        <div class="contact-row">
            <svg width="22" height="16" viewBox="0 0 22 18" fill="none" stroke="currentcolor" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 1H19C20.1 1 21 1.84405 21 2.87566V14.1296C21 15.1612 20.1 16.0052 19 16.0052H3C1.9 16.0052 1 15.1612 1 14.1296V2.87566C1 1.84405 1.9 1 3 1Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M21 2.87561L11 9.44055L1 2.87561"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            email: 
            <span style="font-weight: 600">info@leaf-pool.com</span>
        </div>
        <!-- <div class="contact-row">
            <svg width="22" height="19" viewBox="0 0 22 21" fill="none" stroke="currentcolor" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 1L10 11.3162" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M21 1L14 19.7565L10 11.3161L1 7.56476L21 1Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            telegram group: 
            <span style="font-weight: 600">@leafpool</span>
        </div> -->
    </div>
    <div class="col" style="width: 100%;">
        <div class="title" id="message">Send us a message:</div>
        
        {#if show_message_form}
        <div class="message-row">
            <textarea style="width: 100%;" class:shake rows="2" bind:this={textarea} bind:value={message_input} maxlength="500"></textarea>   <!-- on:keypress={handleKey} -->
            <div on:click={sendMessage} class="button">
                <svg width="20" height="19" viewBox="0 0 20 19" fill="none" stroke="currentcolor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13 7.62683L18 12.316L13 17.0051" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2 2V8.56475C2 9.55966 2.42143 10.5138 3.17157 11.2173C3.92172 11.9208 4.93913 12.316 6 12.316H18" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
        {:else}
        <div class="message-row">
            <div class="message_feedback" on:click={resetMessage}>
                {message_response}
            </div>
            <div class="button" style="max-width: 10rem; height:3.9em" on:click={resetMessage}><b>OK</b></div>
        </div>
        {/if}
        
    </div>
</div>


<style>

.container {
    background-color: var(--clr-background-100);
    transition: background-color 0.3s;

    border-radius: 0.5em;
    border-top: 1px solid rgba(var(--clr-foreground-csv), 0.05);
    box-shadow: 0 1px 2px 0px rgba(0,0,0, 0.25);
    margin-top: 3em;
    margin-bottom: 3em;

    display: flex;
    align-items: stretch;

    font-size: 1em;
    padding-inline: 2em;
    padding-top: 1.5em;
    padding-bottom: 1em;
}

.col {
    display: flex;
    flex-direction: column;
    text-align: left;
}

.title {
    font-weight: 500;
    margin-bottom: 0.7em;
}

.contact-row {
    display: flex;
    gap: 0.7em;
    align-items:center;
    margin-bottom: 0.3em;
}

.message-row {
    display: flex;
    gap: 0.5em;
    width: 100%;
}

.message_feedback {
    width: 100%;
    min-height: 3.9em;
    border-radius: 8px;
    border: 1px solid rgb(223, 223, 223);
    color: rgb(160, 160, 160);
    display:flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-inline: 0.5em;
}

textarea {
    font-family: "Montserrat", sans-serif;
    background-color: var(--clr-background);
    color: var(--clr-foreground);
    font-size: 1em;
    outline: none;
    border-radius: 8px;
    padding: 0.5em;
    resize: none;
    display: block;
    height: 3.8em;
    border: 1px solid rgba(var(--clr-foreground-csv),0.5);
    transition: background-color 0.3s, color 0.3s, border 0.3s;
}



.button {
    border-radius: 8px;
    background-color: #6fca36;
    color: var(--clr-background);
    border: none;
    padding: 0.6em;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: background-color 0.3s, color 0.3s;
}

.shake {
    position:relative;
    animation-name: shake-animation;
    animation-duration: 0.12s;
    animation-iteration-count: 4;
    animation-timing-function: linear;
}

@keyframes shake-animation {
    0% { top: 0px; }
    33% { top:-2px; }
    66% { top:2px; }
    100% { top: 0px; }
}



@media screen and (max-width: 700px)
{
	.container {
        flex-direction: column;
        gap: 1em;
        padding-top: 0.6em;
    }

    .contact-row, .message-row  {
        /* padding-left: 1.5em; */
        justify-content: center;
    }
}


</style>